<template>
  <div v-if="trip" class="trip-main">
    <div class="trip-data">

      <div class="content-block">
        <p>
          <strong>Менеджер заявки:</strong>
          {{ trip.responsible ? trip.responsible.name : '—' }}
        </p>
        <p>
          <strong>Завершен (для рейса):</strong> 
          {{ trip.tms_is_end }}
        </p>
        <p>
          <strong>Тип оборудования трейлер:</strong> 
          {{ trip.tms_equipment_types }}
        </p>
        <p>
          <strong>Товар:</strong> 
          {{ trip.tms_cargo }}
        </p>
        <p>
          <strong>Тариф источника:</strong> 
          {{ formatNumber(trip.tms_price) }}
        </p>
        <p v-if="trip.matrix_price">
          <strong>Тариф ИМ:</strong> 
          <span :class="{'bg-denied white-text':!bgClass,'bg-success':bgClass}" >
          {{ formatNumber(trip.matrix_price) }}</span>
        </p>
        <p v-if="trip.tms_price">
          <strong>Тариф с НДС:</strong> 
          {{ formatNumber(trip.tms_price+trip.tms_price*0.2) }}
        </p>
        <p>
          <strong>НДС:</strong>
          <span v-if="trip.nds"> С НДС</span>
          <span v-else> Без НДС</span>
        </p>
        <p>
          <strong>Общее расстояние:</strong> 
          {{ trip.tms_total_distance }}
        </p>
        <p>
          <strong>Максимальный вес:</strong> 
          {{ trip.tms_max_weight/1000 }}
        </p>
      </div>

      <div class="content-block">
        <p>
          <strong>Сервис:</strong> 
          {{ trip.tms_service }}
        </p>
        <p>
          <strong>Количество грузов:</strong> 
          {{ trip.tms_cargo_quantity }}
        </p>
        
        <p>
          <strong>Финансовый статус груза:</strong> 
          {{ trip.tms_finance_trip_status }}
        </p>
        <p>
          <strong>Тип поставки:</strong> 
          {{ trip.tms_delivery_type }}
        </p>
        <p>
          <strong>Статус запроса на заявку:</strong> 
          {{ trip.tms_request_status }}
        </p>
        <p>
          <strong>Код причины ответа:</strong> 
          {{ trip.tms_response_code }}
        </p>
        <p>
          <strong>Рабочий статус груза:</strong> 
          {{ trip.tms_work_trip_status }}
        </p> 
      </div>
    </div>

    <div class="trip-data">
      <div class="content-block small">
        <p>
          <strong>Ответ требуется до даты:</strong> 
          {{ trip.tms_response_required_date }}
        </p>
        <p>
          <strong>Дата и время начала:</strong> 
          {{ trip.tms_date_start }}
        </p>
        <p>
          <strong>Дата и время завершения:</strong> 
          {{ trip.tms_date_end }}
        </p>
        <p>
          <strong>Дата и время обновления:</strong> 
          {{ trip.tms_date_update }}
        </p>
        <p>
          <strong>Город отправления:</strong> 
          {{ trip.tms_city_out }}
        </p>
        <p>
          <strong>Город назначения:</strong> 
          {{ trip.tms_city_in }}
        </p>
        <p>
          <strong>Адрес отправления:</strong> 
          {{ trip.tms_address_out }}
        </p>
        <p>
          <strong>Адрес назначения:</strong> 
          {{ trip.tms_address_in }}
        </p>

        <p>
          <strong>Получатель:</strong> 
          {{ trip.tms_name_endpoint }}
        </p>
      </div>

    </div>

  </div>
</template>

<script>
import {computed} from 'vue'

export default {
  name: 'TripInfo',
  props: ['trip'],
  setup(props){

    const formatNumber = (number) => {
      return (number / 100).toFixed(2);
    }

    const bgClass = computed(() =>{
      return props.trip.matrix_price === props.trip.tms_price
    })

    return{
      formatNumber,
      bgClass,
      model:'trips'
    }
  }
};
</script>

<style scoped>
.trip-main{

}

.trip-data{
  display: flex;
  justify-content: space-between;
  padding: 25px 10px;
  border-radius: 10px;
  margin-top: 15px;
  border: 1px solid #ccc;
}


.content-block{
  display: flex;
  flex-direction: column;
  font-size: 13px;
}

.white-text{
  color: white;
  padding: 1px;
}

.text-center{
  text-align: center;
}
</style>